// This re-exports the proper environment based on Angular CLI build configuration.
// With the new @angular/build:application builder, we can rely on import alias via tsconfig paths or explicit conditional import via environment injector at runtime.
// Simpler: we'll import both and pick based on a compile-time replacement using tsconfig path mappings set later if needed.
// For now, we will select by checking NODE_ENV-like hint provided by Angular: when building with configuration 'production', process.env['NG_BUILD_MODE'] may not exist in browser.
// So we will let angular.json define a define flag replacing __ENVIRONMENT__ at build time via 'define'. But the builder doesn't expose define here.
// Alternative minimal approach: use environment.production.ts for production and environment.development.ts for dev via dynamic import based on import.meta.env?.MODE in Vite-like, but not available.
// Given constraints, we will expose a runtime-safe selection using a global window.__ENV__ optional override, falling back to development during 'serve' and production during 'build:production' via Ng CLI environment variables are not accessible. We'll base on a compile-time boolean using import.meta.ngDevMode.

import dev from './environment.development';
import prod from './environment.production';

// Angular sets ngDevMode = true in development builds.
// @ts-ignore
const isDev = typeof ngDevMode !== 'undefined' ? !!ngDevMode : true;

// Allow window override if provided
const win = (typeof window !== 'undefined' ? (window as any) : {}) as any;
const override = win.__ENV__ as { production?: boolean; apiBaseUrl?: string } | undefined;

const selected = override
  ? { production: !!override.production, apiBaseUrl: override.apiBaseUrl || (override.production ? prod.apiBaseUrl : dev.apiBaseUrl) }
  : (isDev ? dev : prod);

export const environment = selected;
export default environment;
